import { render, staticRenderFns } from "./BaseSearchCombobox.vue?vue&type=template&id=d2f844bc&lang=pug"
import script from "./BaseSearchCombobox.vue?vue&type=script&lang=js"
export * from "./BaseSearchCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VCombobox,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2f844bc')) {
      api.createRecord('d2f844bc', component.options)
    } else {
      api.reload('d2f844bc', component.options)
    }
    module.hot.accept("./BaseSearchCombobox.vue?vue&type=template&id=d2f844bc&lang=pug", function () {
      api.rerender('d2f844bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/BaseSearchCombobox.vue"
export default component.exports